module.exports = __webpack_public_path__ + "img/TZS09588.aaefcf6f.jpeg";